import { initials } from "../../utils/format";

const PALETTE = ["#4A3FCC", "#1A6FAD", "#0F7A6E", "#8A5800", "#A8386A", "#4E5A72"];

export default function Avatar({ name = "", size = 36 }) {
  const color = PALETTE[[...name].reduce((s, c) => s + c.charCodeAt(0), 0) % PALETTE.length];
  return (
    <span
      className="avatar"
      style={{ width: size, height: size, fontSize: size * 0.38, background: `${color}1A`, color, "--avatar-color": color }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}

export function PersonCell({ name, meta, size = 34 }) {
  return (
    <span className="person-cell">
      <Avatar name={name} size={size} />
      <span className="person-text">
        <span className="person-name">{name}</span>
        {meta && <span className="person-meta">{meta}</span>}
      </span>
    </span>
  );
}
